export interface AccessTokenResponse {
  access_token: string
  expires_in: number
}

export type LoginResponse =
  | AuthenticatedLoginResponse
  | PasswordResetRequiredLoginResponse

export interface AuthenticatedLoginResponse extends AccessTokenResponse {
  status?: 'AUTHENTICATED'
}

export interface PasswordResetRequiredLoginResponse {
  status?: 'PASSWORD_RESET_REQUIRED'
  reset_token: string
  reset_token_expires_in: number
}

export function isAuthenticatedLogin(
  resp: LoginResponse,
): resp is AuthenticatedLoginResponse {
  return (
    typeof (resp as AuthenticatedLoginResponse).access_token === 'string' &&
    (resp as AuthenticatedLoginResponse).access_token.length > 0
  )
}

export function isPasswordResetRequiredLogin(
  resp: LoginResponse,
): resp is PasswordResetRequiredLoginResponse {
  return (
    typeof (resp as PasswordResetRequiredLoginResponse).reset_token ===
      'string' &&
    (resp as PasswordResetRequiredLoginResponse).reset_token.length > 0
  )
}
